import { render, staticRenderFns } from "./popRightClick.vue?vue&type=template&id=2bf0f618"
import script from "./popRightClick.vue?vue&type=script&lang=js"
export * from "./popRightClick.vue?vue&type=script&lang=js"
import style0 from "./popRightClick.vue?vue&type=style&index=0&id=2bf0f618&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bf0f618')) {
      api.createRecord('2bf0f618', component.options)
    } else {
      api.reload('2bf0f618', component.options)
    }
    module.hot.accept("./popRightClick.vue?vue&type=template&id=2bf0f618", function () {
      api.rerender('2bf0f618', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/saleOrder/components/popRightClick/popRightClick.vue"
export default component.exports